"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const Observable_1 = require("rxjs/Observable");
const core_1 = require("@angular/core");
const idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
/**
 * Angular {@link PipeTransform} implementation that transforms a message key into an appropriate text. To accommodate
 * this behavior {@link MessageService} should be injected and used.
 * This pipe is "pure" for performance considerations.
 * @see MessageService
 */
let MessagePipe = class MessagePipe {
    /**
     * Creates the pipe component.
     * @param {!MessageService} messageService - An instance of {@link MessageService} should be injected.
     */
    constructor(messageService) {
        this.messageService = messageService;
    }
    /**
     * The transformation function imposed by the {@link PipeTransform} interface.
     * @param {string} key - Transformation subject: the message key.
     * @returns {Observable<string>} Transformation object: the actual text corresponding to the specified key.
     * @override
     */
    transform(key) {
        key = key ? key.trim() : "";
        if (key.length == 0) {
            return Observable_1.Observable.from([""]);
        }
        return this.messageService.getMessage(key);
    }
};
MessagePipe = __decorate([
    core_1.Pipe({
        name: 'message',
        pure: true
    }),
    __metadata("design:paramtypes", [idm_message_language_service_client_js_1.MessageService])
], MessagePipe);
exports.MessagePipe = MessagePipe;
//# sourceMappingURL=message.pipe.js.map